import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { EntityType } from '~/enums/EntityType';
import { slices } from '~/redux/slices';
import { RoutePathType } from '~/routing/enums';
import { useRouting } from '~/routing/useRouting';
import { capitalize } from '~/utils/strings';

import { TargetEntity } from '../types/entity';

export const useCreateAction = (entityType: TargetEntity['type']) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { navigate } = useRouting();

  const entityDisplayType =
    entityType === EntityType.DocumentAttachedData
      ? intl.formatMessage({
          id: 'UseCreateAction.tableEntity',
          defaultMessage: 'Table',
          description: 'Label for the table entity type',
        })
      : capitalize(entityType);

  return {
    level: 'primary' as const,
    text: intl.formatMessage(
      {
        id: 'useCreateAction.newModelText',
        defaultMessage: 'New {entityType} Model',
        description:
          'Button text for creating a new model. Example: entityType = "Field" | "Table"',
      },
      {
        entityType: entityDisplayType,
      },
    ),
    onClick: () => {
      switch (entityType) {
        case EntityType.DocumentAttachedData:
          dispatch(slices.xRay.actions.resetXRay());
          navigate(`${RoutePathType.AutomationHubFields}/new?type=table`);
          break;
        case EntityType.Field:
        default:
          dispatch(slices.xRay.actions.resetXRay());
          navigate(`${RoutePathType.AutomationHubFields}/new`);
      }
    },
  };
};
